import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ColumnWidget from 'Components/ColumnWidget/';
import {
  SingleListSelectorPanel,
  SingleListSelectorHeading,
  SingleListSelectorList,
} from 'Components/SingleListSelector';
import PlusIcon from 'Components/icons/PlusIcon';
import Search from 'Components/search/Search.jsx';

import {
  getActiveColumns,
} from 'Utils/dualListSelectorUtils';
import {
  calcuateDynamicMultiSelectFiltersCount
} from 'Utils/dynamicListSelectorUtil';
import './SingleListSelector.scss';

class SingleListSelector extends Component {
  constructor(props) {
    super(props);

    const { availableColumns, activeColumns, isDialog } = this.props;
    this.state = {
      availableColumns: availableColumns,
      activeColumns: activeColumns,
      availableFilter: '',
      isDialog,
      dynamicMultiSelectArray: calcuateDynamicMultiSelectFiltersCount(activeColumns),
    };
    this.attachBindings();
  }

  attachBindings() {
    this.addColumn = this.addColumn.bind(this);
  }

  componentDidMount() {
    this.props.onRef(this); // eslint-disable-line react/prop-types
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.isDialog) return;

    if (JSON.stringify(nextProps.availableColumns) !== JSON.stringify(this.state.availableColumns) ||
      (JSON.stringify(nextProps.activeColumns) !== JSON.stringify(this.state.activeColumns))) {
      const { availableColumns, activeColumns } = nextProps;
      const newAvailableColumns = availableColumns;
      const newActiveColumns = getActiveColumns(activeColumns);

      this.setState({
        availableColumns: newAvailableColumns,
        activeColumns: newActiveColumns,
      });
    }
  }

  componentWillUnmount() {
    this.props.onRef(undefined); // eslint-disable-line react/prop-types
  }

  setAvailableSearchFilter = (newText) => {
    this.setState({ availableFilter: newText });
  }

  addColumn = (identifier) => {
    const { availableColumns, activeColumns } = this.state;
    let columnToMove = availableColumns.find((column) => column.elementId === identifier);
    if (columnToMove) {
      let multiSelectColumn = this.state.dynamicMultiSelectArray.find(data => data.elementId === identifier);
      let newAvailableColumns = [...availableColumns];
       if (multiSelectColumn) {
         columnToMove = { ...columnToMove, updatedId: `${columnToMove.elementId}@${multiSelectColumn.count + 1}` };
       }
       else if (columnToMove.elementTypeName === 'DYNAMIC_MULTITEXT') {
         columnToMove = { ...columnToMove, updatedId: `${columnToMove.elementId}@1` };
         newAvailableColumns = availableColumns.filter((column) => column.elementId !== identifier);
         this.setState((prevState) => ({
           dynamicMultiSelectArray: prevState.dynamicMultiSelectArray.concat({ elementId: columnToMove.elementId, count: 1 })
         }))
       }
      else {
        newAvailableColumns = availableColumns.filter((column) => column.elementId !== identifier);
     }
      
      const newActiveColumns = [...activeColumns, columnToMove];

      this.setState({
        availableColumns: newAvailableColumns,
        activeColumns: newActiveColumns,
      }, () => {
        this.updateColumns(newAvailableColumns, newActiveColumns);
      });
    }
  }


  updateColumns = (newAvailableColumns, newActiveColumns) => {
    this.props.updateColumnsInfo({
      availableColumns: newAvailableColumns,
      activeColumns: newActiveColumns,
    });
  }

  render() {
    const {
      availableFilter,
      availableColumns,
    } = this.state;

    const { extraClass, translations, } = this.props;

    const wrapperClass = classnames('single-list-selector', {
      [extraClass]: extraClass,
    });

    const availableFilteredColumns = availableColumns
      .filter((column) => column.elementLabel.toLowerCase().includes(availableFilter.toLowerCase()));
    const availableColumnWidgets = availableFilteredColumns
      //.filter((column) => column.displayType !== 'NONE' && column.displayType !== 'EXPORT_ONLY' && column.displayType !== 'ICON')
      .sort((columnA, columnB) => {
        return Number(columnA.displayOrder) - Number(columnB.displayOrder);
      })
      .map((column) => {
        const extraActions = [
          {
            callback: this.addColumn,
            icon: PlusIcon,
          },
        ];
        return (
          <ColumnWidget
            actions={extraActions}
            desc={column.elementLabel}
            extraClass=""
            identifier={column.elementId}
            isHidden={false}
            isReadOnly={true}
            key={column.elementId}
            name={column.elementLabel}
            id={`${this.props.id}_ColumnWidget`}
            hideToolTip={true}
          />
        );
      });

    return (
      <div className={wrapperClass}>
        <SingleListSelectorPanel
          extraClass={extraClass}
        >
          <SingleListSelectorHeading
            title={translations.availableFilterText}
          />
          <Search
            id={`${this.props.id}_columnManager_textbox_Search_Available_Columns`}
            filterText={availableFilter}
            onChange={this.setAvailableSearchFilter}
            placeholder={translations.searchAvailableFilters}
          />
          <div
            className="single-list-selector__list-wrapper"
          >
            <SingleListSelectorList>
              {availableColumnWidgets}
            </SingleListSelectorList>
          </div>
        </SingleListSelectorPanel>
      </div>
    );
  }
}

SingleListSelector.propTypes = {
  availableColumns: PropTypes.array.isRequired,
  activeColumns: PropTypes.array.isRequired,
  extraClass: PropTypes.string,
  id: PropTypes.string,
  isDialog: PropTypes.bool.isRequired,
  updateColumnsInfo: PropTypes.func,
  handleOnApplyActiveColumns: PropTypes.func,
  handleOnUpdateActiveColumns: PropTypes.func,
  doubleWidth: PropTypes.bool,
  translations: PropTypes.object,
  showVisibility: PropTypes.bool,
};

SingleListSelector.defaultProps = {
  extraClass: 'available-columns',
  id: '',
  updateColumnsInfo: () => { },
  handleOnApplyActiveColumns: () => { },
  handleOnUpdateActiveColumns: () => { },
  doubleWidth: false,
  translations: {
    availableColumns: 'Available Columns',
    searchAvailableColumns: 'Search Available Columns',
    addAll: 'Add All',
    activeColumns: 'Active Columns',
    searchActiveColumns: 'Search Active Columns',
    removeAll: 'Remove All',
    showAll: 'Show All',
    hideAll: 'Hide All',
  },
  showVisibility: false,
};

export default SingleListSelector;
